export const environment = {
  production: true,
  clientId : 'c66fd82a-4e71-4643-8e08-14c68c4f7646'
};
